<template>    
    <div class="mb-4">
        <div id="accordion">
            <a class="schedule-box__a-collapse" href="JavaScript:void(0);" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Learn About Schedule Box Indicators
            </a>
            <div id="collapseOne" class="collapse mt-2 pl-3 py-2 shadow-sm rounded bg-white" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="schedule-box">
                    <span class="schedule-box schedule-box--yellow d-inline-block" /> Indicates that an associate has been assigned the same assignment on the same day as another employee in different rotations.
                </div>
                <div class="schedule-box">
                    <span class="schedule-box schedule-box--red d-inline-block" /> Indicates that an associate has been assigned to the same day on multiple rotations.
                </div>
                <div class="schedule-box">
                    <span class="schedule-box schedule-box--orange d-inline-block" /> Indicates that an associate has been assigned to different assignments on the same day within this rotation.
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name:   'Indications',
    
}
</script>